import { ComponentRule, ComponentRules, MaxLengthRule, MaxValueRule, MinLengthRule, MinValueRule } from './ComponentRule';

class ComponentRuleBuilder {
  private readonly rules: ComponentRule[];

  constructor() {
    this.rules = [];
  }

  public static rule() {
    return new ComponentRuleBuilder();
  }

  public required() {
    this.rules.push({ type: ComponentRules.REQUIRED });
    return this;
  }

  public minLength(minLength: number) {
    this.rules.push({ type: ComponentRules.MIN_LENGTH, minLength } as MinLengthRule);
    return this;
  }

  public maxLength(maxLength: number) {
    this.rules.push({ type: ComponentRules.MAX_LENGTH, maxLength } as MaxLengthRule);
    return this;
  }

  public minValue(minValue: number) {
    this.rules.push({ type: ComponentRules.MIN_VALUE, minValue } as MinValueRule);
    return this;
  }

  public maxValue(maxValue: number) {
    this.rules.push({ type: ComponentRules.MAX_VALUE, maxValue } as MaxValueRule);
    return this;
  }

  public custom(rule: (value: any) => boolean) {
    this.rules.push({ type: ComponentRules.CUSTOM, rule } as ComponentRule);
    return this;
  }

  public build() {
    return this.rules;
  }
}

export default ComponentRuleBuilder;
